import React, { useEffect, useState } from 'react';
import classes from 'components/modalTagNumberRange/modalTagNumberRange.module.scss';
import constants from 'services/constants';
import helpers from 'services/helpers';
import PropTypes from 'prop-types';
import { tableColumns } from 'services/tableColumns';
import AddTagRange from 'components/addTagRange/addTagRange';
import ErrorLabel from 'components/base/errorLabel/errorLabel';
import Table from 'components/table/table';

const ModalTagNumberRange = ({
  addRange,
  clearAll,
  modalAnimals,
  removeAllInvalid,
  removeAnimal,
  setModal,
  setModalAnimals,
  species
}) => {
  const [paginationParams, setPaginationParams] = useState(constants.pagination.defaultParams);

  useEffect(() => {
    setPaginationParams((prevState) => ({
      ...prevState,
      [constants.pagination.bottom]: {
        ...prevState[constants.pagination.bottom],
        total: modalAnimals?.length
      }
    }));
  }, [modalAnimals]);

  return (
    <div className={classes.content}>
      <div className={classes.input}>
        <AddTagRange
          setAnimalsToChange={addRange}
          setModal={setModal}
          species={species}
        />
      </div>

      {modalAnimals?.some((tag) => helpers.tag.isInvalid(tag)) &&
        <ErrorLabel
          label="formatExamples.tagBatchError"
          modalMessage={helpers.tag.getFormatExamples(species.id).description}
          modalTitle={helpers.tag.getFormatExamples(species.id).title}
          setModal={setModal}
        />
      }

      {modalAnimals?.length > 0 &&
        <div className={classes.output}>
          <div className={classes.tableContainer}>
            <Table
              clearAll={clearAll}
              columns={tableColumns.movements.modalTagNumberRange({ actionFunction: removeAnimal, sortable: true })}
              data={modalAnimals}
              dataProvided={true}
              paginationParams={paginationParams}
              removeAllInvalid={removeAllInvalid}
              setData={setModalAnimals}
              setModal={setModal}
              title={{
                title: 'table.title.animalsEntered',
                data: [
                  modalAnimals?.length
                ]
              }}
            />
          </div>
        </div>
      }
    </div>
  );
};

ModalTagNumberRange.propTypes = {
  addRange: PropTypes.func.isRequired,
  clearAll: PropTypes.func.isRequired,
  modalAnimals: PropTypes.array.isRequired,
  removeAllInvalid: PropTypes.func.isRequired,
  removeAnimal: PropTypes.func.isRequired,
  setModal: PropTypes.func.isRequired,
  setModalAnimals: PropTypes.func.isRequired,
  species: PropTypes.exact({
    id: PropTypes.number,
    name: PropTypes.string,
    notifications: PropTypes.number,
    errorFound: PropTypes.number
  }).isRequired
};

export default ModalTagNumberRange;
